// Huddle: the phone-first community, rec and youth website template.
// Eager and tiny: the template module loads lazily through `load`.

import { defineManifest } from '../../core/template/defineTemplate'
import { SITE_TEMPLATE_CONTRACT } from '../../core/template/types'
import { HUDDLE_OPTIONS } from './options'
import thumb from './thumbnail.webp'

export default defineManifest({
  id: 'huddle',
  name: 'Huddle',
  // Picker text: the admin catalogue (siteTemplates.huddle), in the admin's language (#1063).
  description: (m) => m.siteTemplates.huddle.description,
  bestFor: (m) => m.siteTemplates.huddle.bestFor,
  status: 'stable',
  contract: SITE_TEMPLATE_CONTRACT,
  // Picker card: the fictional Ironbridge league (never a real tenant).
  thumbnail: thumb,
  options: HUDDLE_OPTIONS,
  fonts: [
    'https://fonts.googleapis.com/css2?family=Atkinson+Hyperlegible:ital,wght@0,400;0,700;1,400&family=Bricolage+Grotesque:opsz,wdth,wght@12..96,75..100,400..800&display=swap',
  ],
  capabilities: { homeColumns: false, homeMobileOrder: true },
  load: () => import('./template'),
})
